import { SvgIcon } from '@mui/material';

const BinocularIcon = ({ fill = '#87939D', ...props }) => (
    <SvgIcon viewBox="0 0 16 16" {...props}>
        <path d="M9.37515 0.901367H12.0876V2.83887H9.37515V0.901367Z" fill={fill} />
        <path d="M6.31265 9.27129C6.57515 9.27129 6.77515 9.05879 6.77515 8.80879V3.44629H2.67515L0.950147 10.7588L0.962646 11.2338V14.4713C0.962646 14.7213 1.16265 14.9213 1.41265 14.9213H5.40015C5.65015 14.9213 5.85015 14.7213 5.85015 14.4713V9.27129H6.27515" fill={fill} />
        <path d="M9.85015 9.28887C9.58765 9.28887 9.38765 9.07637 9.38765 8.82637V3.46387H13.4751L15.2126 10.7764L15.2001 11.2514V14.4889C15.2001 14.7389 15.0001 14.9389 14.7501 14.9389H10.7626C10.5126 14.9389 10.3126 14.7389 10.3126 14.4889V9.28887H9.88765" fill={fill} />
        <path d="M7.38735 3.46387H8.78735V8.43887H7.38735V3.46387Z" fill={fill} />
        <path d="M4.06265 0.901367H6.77515V2.83887H4.06265V0.901367Z" fill={fill} />
    </SvgIcon>
);

export default BinocularIcon;